import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, Select, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { supabase } from "../supabase";

const Milestones = () => {
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingMilestone, setEditingMilestone] = useState(null);
  const [form] = Form.useForm();
  const [students, setStudents] = useState([]);

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const { data, error } = await supabase.from("students").select("id, name");
      if (error) throw error;
      setStudents(data);
    } catch (error) {
      message.error("Error fetching students");
    }
  };

  useEffect(() => {
    fetchMilestones();
  }, []);

  const fetchMilestones = async () => {
    try {
      const { data, error } = await supabase
        .from("student_milestones")
        .select(`
          *,
          students (name)
        `);
      if (error) throw error;
      setMilestones(data);
    } catch (error) {
      message.error("Error fetching milestones");
    } finally {
      setLoading(false);
    }
  };

  const showModal = (milestone = null) => {
    setEditingMilestone(milestone);
    setIsModalVisible(true);
    if (milestone) {
      form.setFieldsValue(milestone);
    } else {
      form.resetFields();
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    try {
      if (editingMilestone) {
        const { error } = await supabase
          .from("student_milestones")
          .update(values)
          .eq("id", editingMilestone.id);
        if (error) throw error;
        message.success("Milestone updated successfully");
      } else {
        const { error } = await supabase.from("student_milestones").insert([values]);
        if (error) throw error;
        message.success("Milestone added successfully");
      }
      fetchMilestones();
      handleCancel();
    } catch (error) {
      message.error("Error saving milestone");
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Student Name",
      dataIndex: ["students", "name"],
      key: "student_name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Button onClick={() => showModal(record)}>Edit</Button>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => showModal()}
        style={{ marginBottom: 16 }}
      >
        Add Milestone
      </Button>
      <Table columns={columns} dataSource={milestones} loading={loading} rowKey="id" />
      <Modal
        title={editingMilestone ? "Edit Milestone" : "Add Milestone"}
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={form.submit}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="student_id"
            label="Student"
            rules={[{ required: true, message: "Please select a student!" }]}
          >
            <Select>
              {students.map((student) => (
                <Select.Option key={student.id} value={student.id}>
                  {student.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true, message: "Please input the title!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Please input the description!" }]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Milestones;
